// Wrapper léger autour de MediaRecorder. start() / stop() -> Blob.
export function createRecorder() {
  let mediaRecorder = null;
  let chunks = [];
  let stream = null;

  function pickMimeType() {
    const candidates = ["audio/webm", "audio/mp4", "audio/ogg"];
    for (const c of candidates) {
      if (typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported(c)) {
        return c;
      }
    }
    return "";
  }

  async function start() {
    stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    chunks = [];
    const mimeType = pickMimeType();
    mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
    mediaRecorder.ondataavailable = (e) => {
      if (e.data && e.data.size > 0) chunks.push(e.data);
    };
    // timeslice : flush régulier des données — fiabilise iOS Safari / Edge iOS
    // (sans ça, le blob peut être vide / « audio too short »).
    mediaRecorder.start(250);
  }

  function stop() {
    return new Promise((resolve) => {
      if (!mediaRecorder) return resolve(null);
      mediaRecorder.onstop = () => {
        const type = mediaRecorder.mimeType || "audio/webm";
        const blob = new Blob(chunks, { type });
        if (stream) stream.getTracks().forEach((t) => t.stop());
        mediaRecorder = null;
        stream = null;
        resolve(blob.size > 0 ? blob : null);
      };
      try {
        if (mediaRecorder.state === "recording" && mediaRecorder.requestData) {
          mediaRecorder.requestData();
        }
        mediaRecorder.stop();
      } catch (e) {
        resolve(null);
      }
    });
  }

  return { start, stop };
}
